<template>
  <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="productApplicationVO.pkId > 0 ? '编辑' : '新建'"
      width="1200px"
      top="2vh"
      @close="dialogClose">
    <el-tabs v-model="defaultTabName">
      <el-tab-pane name="p1" label="基本信息">
        <el-form
            ref="form"
            :model="productApplicationVO"
            :rules="ruleValidate"
            class="form"
            label-width="80px" :disabled="disabled">
          <el-row>
            <el-col :span="6">
              <el-form-item label="编号">
                <el-input v-model="productApplicationVO.no" disabled/>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产品名称" prop="productName">
                <el-input v-model="productApplicationVO.productName" placeholder="请输入"/>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产品代码" prop="productCode">
                <el-input v-model="productApplicationVO.productCode"/>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产品类型" prop="productCategory">
                <el-select v-model="productApplicationVO.productCategory" @change="categoryChange()">
                  <el-option :value="10" label="滤波器"/>
                  <el-option :value="20" label="变压器"/>
                  <el-option :value="30" label="解谐电抗器"/>
                  <el-option :value="40" label="电抗器"/>
                  <el-option :value="50" label="电阻"/>
                  <el-option :value="60" label="高频电感"/>
                  <el-option :value="70" label="高压"/>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="产品规格" prop="specificationType"
                            v-if="[10,30,50].includes(productApplicationVO.productCategory)">
                <el-input v-model="productApplicationVO.specificationType"/>
              </el-form-item>
              <el-form-item label="产品规格" prop="specificationType"
                            v-if="[20].includes(productApplicationVO.productCategory)">
                <el-checkbox-group v-model="productSpecification" :max="1" @change="changeSpecification()">
                  <el-checkbox label="BKDC(A)"/>
                  <el-checkbox label="BKSC(A)"/>
                  <el-checkbox label="BYDC(A)"/>
                  <el-checkbox label="BYSC(A)"/>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="产品规格" prop="specificationType"
                            v-if="[40,70].includes(productApplicationVO.productCategory)">
                <el-checkbox-group v-model="productSpecification" :max="1" @change="changeSpecification()">
                  <el-checkbox label="ACR"/>
                  <el-checkbox label="DCR"/>
                  <el-checkbox label="OCR"/>
                  <el-checkbox label="SFR"/>
                  <el-checkbox label="VTR"/>
                  <el-checkbox label="BCR"/>
                  <el-checkbox label="BOR"/>
                  <el-checkbox label="BFR"/>
                  <el-checkbox label="LCL"/>
                  <el-checkbox label="LOR"/>
                  <el-checkbox label="HFR"/>
                  <el-checkbox label="EFR"/>
                  <el-checkbox label="CFR"/>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="产品规格" prop="specificationType"
                            v-if="[60].includes(productApplicationVO.productCategory)">
                <el-checkbox-group v-model="productSpecification" :max="1" @change="changeSpecification()">
                  <el-checkbox label="ACR"/>
                  <el-checkbox label="DCR"/>
                  <el-checkbox label="OCR"/>
                  <el-checkbox label="SFR"/>
                  <el-checkbox label="VTR"/>
                  <el-checkbox label="BCR"/>
                  <el-checkbox label="BOR"/>
                  <el-checkbox label="BFR"/>
                  <el-checkbox label="LCL"/>
                  <el-checkbox label="LOR"/>
                  <el-checkbox label="HFR"/>
                  <el-checkbox label="EFR"/>
                  <el-checkbox label="CFR"/>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="客户名称" prop="customerName">
                <el-input v-model="productApplicationVO.customerName" placeholder="请选择客户">
                  <el-button
                      slot="append"
                      icon="el-icon-search"
                      :disabled="productApplicationVO.pkid > 0"
                      @click="$refs.selectCustomerName.open()"/>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="客户编号" prop="customerNo">
                <el-input v-model="productApplicationVO.customerNo"/>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="客户类别" prop="customerLevel">
                <el-select v-model="productApplicationVO.customerLevel">
                  <el-option v-for="item in customerLevels" :key="item.value" :label="item.label" :value="item.value"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="交货部门" prop="materialTypeName">
                <el-input v-model="productApplicationVO.materialTypeName" readonly>
                  <el-button slot="append" icon="el-icon-search" @click="$refs.selectMaterialType.open()"/>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="预计用量" prop="preOrderQty">
                <el-input type="number" v-model="productApplicationVO.preOrderQty" style="width: 120px;"
                          @input="productApplicationVO.preOrderQty = String(productApplicationVO.preOrderQty).replace(/[^\d.]/g, '')"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="备注">
            <el-input v-model="productApplicationVO.note" type="textarea" placeholder="请输入"/>
          </el-form-item>
        </el-form>
        <div
            style="text-align: center;border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px">
          技术参数(带*为必须填写项目)
        </div>
        <!--10-->
        <div v-if="showP10">
          <el-form ref="form"
                   :model="p10"
                   :rules="showP10? ruleValidateP10:ruleValidate0"
                   class="form"
                   style="height: 450px;"
                   label-width="80px" :disabled="disabled">
            <el-row>
              <el-col :span="12">
                <el-form-item label="电流" prop="dianliu_10">
                  <el-input v-model="p10.dianliu_10"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="电压" prop="dianya_10">
                  <el-input v-model="p10.dianya_10"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="必选" prop="danxiang_10">
                  <el-checkbox-group v-model="p10.listDanxiang_10" :max="1" @change="changeP10Danxiang()">
                    <el-checkbox label="单相"/>
                    <el-checkbox label="三相"/>
                    <el-checkbox label="三相四线"/>
                    <el-checkbox label="直流"/>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="尺寸" prop="chicun_10">
                  <el-checkbox-group v-model="p10.listChicun_10" :max="1" @change="changeP10Chicun()">
                    <el-checkbox label="标准尺寸"/>
                    <el-checkbox label="定制尺寸"/>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="客户需求" prop="note_10">
                  <el-input type="textarea" v-model="p10.note_10" autosize/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="使用场所" prop="changsuo_10">
                  <el-input type="textarea" v-model="p10.changsuo_10" autosize/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-checkbox style="margin-left: 20px;" v-model="p10.optionPrice" label="报价"/>
                <el-checkbox v-model="p10.optionDemo" label="打样"/>
                <el-checkbox v-model="p10.optionSpecification" label="规格书"/>
                <el-checkbox v-model="p10.optionClient" label="承认书"/>
                <el-checkbox v-model="p10.optionBom" label="物料清单"/>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <!--20-->
        <div v-if="showP20">
          <el-form ref="form"
                   :model="p20"
                   :rules="showP20? ruleValidateP20:ruleValidate0"
                   class="form"
                   style="height: 200px;"
                   label-width="140px" :disabled="disabled">
            <el-row>
              <el-col :span="8">
                <el-form-item label="单相,三相/隔离,自耦" prop="danxiang_20">
                  <el-input v-model="p20.danxiang_20"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="容量（功率）KW" prop="rongliang_20">
                  <el-input v-model="p20.rongliang_20"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="初级电压（输入）" prop="chujidianya_20">
                  <el-input v-model="p20.chujidianya_20"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="次级电压（输出）" prop="cijidianya_20">
                  <el-input v-model="p20.cijidianya_20"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="初级额定电流(A)" prop="chujidianliu_20">
                  <el-input v-model="p20.chujidianliu_20"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="次级额定电流(A)" prop="cijidianliu_20">
                  <el-input v-model="p20.cijidianliu_20"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="基波频率(Hz)" prop="jiboHz_20">
                  <el-input v-model="p20.jiboHz_20"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="开关频率(KHz)" prop="kaiguanHz_20">
                  <el-input v-model="p20.kaiguanHz_20"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="温升(K)" prop="wensheng_20">
                  <el-input v-model="p20.wensheng_20"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="效率(%)" prop="xiaolv_20">
                  <el-input v-model="p20.xiaolv_20"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="导体材料(铜/铝）" prop="daoti_20">
                  <el-input v-model="p20.daoti_20"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="尺寸要求" prop="chicun_20">
                  <el-input v-model="p20.chicun_20"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="其它" prop="note_20">
                  <el-input type="textarea" v-model="p20.note_20" autosize/>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div
              style="text-align: center;border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px">
            特殊要求(带*为必须填写项目)
          </div>
          <el-form ref="form"
                   :model="p20"
                   :rules="showP20? ruleValidateP20:ruleValidate0"
                   class="form"
                   label-width="140px" :disabled="disabled">
            <el-row>
              <el-col :span="8">
                <el-form-item label="有无客户文件" prop="filename_20">
                  <el-input v-model="p20.filename_20"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="有无测试要求" prop="test_20">
                  <el-input v-model="p20.test_20"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="有无出口要求" prop="chukou_20">
                  <el-input v-model="p20.chukou_20"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="过载要求（过载时电感跌落要求）" label-width="350px" prop="guozai_20">
                  <el-input v-model="p20.guozai_20"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="接线排表面（如镀锡/镀镍）" label-width="350px" prop="jiexianpai_20">
                  <el-input v-model="p20.jiexianpai_20"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="有无客户样品（是完全按照样品设计还是按我司设计）" label-width="350px" prop="demo_20">
                  <el-input v-model="p20.demo_20"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="使用场所（如使用于变频器/风电/电动车/光伏等）" label-width="350px" prop="changsuo_20">
                  <el-input v-model="p20.changsuo_20"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="防护要求(如ROHS/72小时盐雾/UL/三防等）" label-width="350px" prop="fanghu_20">
                  <el-input v-model="p20.fanghu_20"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-checkbox style="margin-left: 20px;" v-model="p20.optionPrice" label="报价"/>
                <el-checkbox v-model="p20.optionDemo" label="打样"/>
                <el-checkbox v-model="p20.optionSpecification" label="规格书"/>
                <el-checkbox v-model="p20.optionClient" label="承认书"/>
                <el-checkbox v-model="p20.optionBom" label="物料清单"/>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <!--30-->
        <div v-if="showP30">
          <el-form ref="form"
                   :model="p30"
                   :rules="showP30? ruleValidateP30:ruleValidate0"
                   class="form"
                   style="height: 200px;"
                   label-width="140px" :disabled="disabled">
            <el-row>
              <el-col :span="8">
                <el-form-item label="单相/三相" prop="danxiang_30">
                  <el-input v-model="p30.danxiang_30"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="电感量(mH)" prop="diangan_30">
                  <el-input v-model="p30.diangan_30"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="电容容量（KVAR)" prop="dianrongrongliang_30">
                  <el-input v-model="p30.dianrongrongliang_30"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="额定电流（A)" prop="dianliu_30">
                  <el-input v-model="p30.dianliu_30"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="系统工作电压（V）" prop="dianya_30">
                  <el-input v-model="p30.dianya_30"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="温升（K)" prop="wensheng_30">
                  <el-input v-model="p30.wensheng_30"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="电容电压（V）" prop="dianrongdianya_30">
                  <el-input v-model="p30.dianrongdianya_30"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="冷却方式" prop="lengque_30">
                  <el-input v-model="p30.lengque_30"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="电抗率（%）" prop="diankang_30">
                  <el-input v-model="p30.diankang_30"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="噪音(dB)" prop="zaoyin_30">
                  <el-input v-model="p30.zaoyin_30"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="导体材料(铜/铝）" prop="daoti_30">
                  <el-input v-model="p30.daoti_30"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="尺寸要求" prop="chicun_30">
                  <el-input v-model="p30.chicun_30"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="其它" prop="note_30">
                  <el-input type="textarea" v-model="p30.note_30" autosize/>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div
              style="text-align: center;border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px">
            特殊要求(带*为必须填写项目)
          </div>
          <el-form ref="form"
                   :model="p30"
                   :rules="showP30? ruleValidateP30:ruleValidate0"
                   class="form"
                   label-width="140px" :disabled="disabled">
            <el-row>
              <el-col :span="8">
                <el-form-item label="有无客户文件" prop="filename_30">
                  <el-input v-model="p30.filename_30"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="有无测试要求" prop="test_30">
                  <el-input v-model="p30.test_30"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="有无出口要求" prop="chukou_30">
                  <el-input v-model="p30.chukou_30"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="过载要求（过载时电感跌落要求）" label-width="350px" prop="guozai_30">
                  <el-input v-model="p30.guozai_30"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="接线排表面（如镀锡/镀镍）" label-width="350px" prop="jiexian_30">
                  <el-input v-model="p30.jiexian_30"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="有无客户样品（是完全按照样品设计还是按我司设计）" label-width="350px" prop="demo_30">
                  <el-input v-model="p30.demo_30"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="防护要求(如ROHS/72小时盐雾/UL/三防等）" label-width="350px" prop="fanghu_30">
                  <el-input v-model="p30.fanghu_30"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-checkbox style="margin-left: 20px;" v-model="p30.optionPrice" label="报价"/>
                <el-checkbox v-model="p30.optionDemo" label="打样"/>
                <el-checkbox v-model="p30.optionSpecification" label="规格书"/>
                <el-checkbox v-model="p30.optionClient" label="承认书"/>
                <el-checkbox v-model="p30.optionBom" label="物料清单"/>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <!--40-->
        <div v-if="showP40">
          <el-form ref="form"
                   :model="p40"
                   :rules="showP40? ruleValidateP40:ruleValidate0"
                   class="form"
                   style="height: 200px;"
                   label-width="140px" :disabled="disabled">
            <el-row>
              <el-col :span="8">
                <el-form-item label="单相/三相" prop="danxiang_40">
                  <el-input v-model="p40.danxiang_40"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="系统工作电压（U)" prop="dianya_40">
                  <el-input v-model="p40.dianya_40"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="功率（变频器KW）" prop="gonlv_40">
                  <el-input v-model="p40.gonlv_40"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="电感量(mH)" prop="diangan_40">
                  <el-input v-model="p40.diangan_40"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="额定电流（A)" prop="dianliu_40">
                  <el-input v-model="p40.dianliu_40"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="基波频率（Hz）" prop="jiboHz_40">
                  <el-input v-model="p40.jiboHz_40"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="温升（K)" prop="wensheng_40">
                  <el-input v-model="p40.wensheng_40"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="导体材料(铜/铝）" prop="daoti_40">
                  <el-input v-model="p40.daoti_40"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="开关频率（KHz）" prop="kaiguanHz_40">
                  <el-input v-model="p40.kaiguanHz_40"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="绝缘等级（H/F)" prop="jueyuan_40">
                  <el-input v-model="p40.jueyuan_40"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="噪音(dB)" prop="zaoyin_40">
                  <el-input v-model="p40.zaoyin_40"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="冷却方式" prop="lengque_40">
                  <el-input v-model="p40.lengque_40"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="尺寸要求" prop="chicun_40">
                  <el-input v-model="p40.chicun_40"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="连接方式" prop="lianjie_40">
                  <el-checkbox-group v-model="p40.listLianjie_40" :max="1" @change="changeP40Lianjie()">
                    <el-checkbox label="硬连接"/>
                    <el-checkbox label="软连接"/>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="其它" prop="note_40">
                  <el-input type="textarea" v-model="p40.note_40" autosize/>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div
              style="text-align: center;border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px">
            特殊要求(带*为必须填写项目)
          </div>
          <el-form ref="form"
                   :model="p40"
                   :rules="showP40? ruleValidateP40:ruleValidate0"
                   class="form"
                   label-width="140px" :disabled="disabled">
            <el-row>
              <el-col :span="8">
                <el-form-item label="有无客户文件" prop="filename_40">
                  <el-input v-model="p40.filename_40"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="有无测试要求" prop="test_40">
                  <el-input v-model="p40.test_40"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="有无出口要求" prop="chukou_40">
                  <el-input v-model="p40.chukou_40"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="过载要求（过载时电感跌落要求）" label-width="350px" prop="guozai_40">
                  <el-input v-model="p40.guozai_40"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="接线排表面（如镀锡/镀镍）" label-width="350px" prop="jiexian_40">
                  <el-input v-model="p40.jiexian_40"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="有无客户样品（是完全按照样品设计还是按我司设计）" label-width="350px" prop="demo_40">
                  <el-input v-model="p40.demo_40"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="使用场所（如使用于变频器/风电/电动车/光伏等）" label-width="350px" prop="changsuo_40">
                  <el-input v-model="p40.changsuo_40"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="防护要求(如ROHS/72小时盐雾/UL/三防等）" label-width="350px" prop="fanghu_40">
                  <el-input v-model="p40.fanghu_40"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-checkbox style="margin-left: 20px;" v-model="p40.optionPrice" label="报价"/>
                <el-checkbox v-model="p40.optionDemo" label="打样"/>
                <el-checkbox v-model="p40.optionSpecification" label="规格书"/>
                <el-checkbox v-model="p40.optionClient" label="承认书"/>
                <el-checkbox v-model="p40.optionBom" label="物料清单"/>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <!--50-->
        <div v-if="showP50">
          <el-form ref="form"
                   :model="p50"
                   :rules="showP50? ruleValidateP50:ruleValidate0"
                   class="form"
                   style="height: 450px;"
                   label-width="80px" :disabled="disabled">
            <el-row>
              <el-col :span="12">
                <el-form-item label="功率" prop="gonglv_50">
                  <el-input v-model="p50.gonglv_50"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="阻值" prop="zuzhi_50">
                  <el-input v-model="p50.zuzhi_50"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="系统电压" prop="dianya_50">
                  <el-input v-model="p50.dianya_50"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="耐压" prop="naiya_50">
                  <el-input v-model="p50.naiya_50"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="认证要求" prop="renzheng_50">
                  <el-checkbox-group v-model="p50.listRenzheng_50" :max="1" @change="changeP50Renzheng()">
                    <el-checkbox label="ROHS"/>
                    <el-checkbox label="UL"/>
                    <el-checkbox label="其他"/>
                    <el-checkbox label="无"/>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>

            </el-row>
            <el-row style="height: 80px;">
              <el-col :span="24">
                <el-form-item label="电阻类型" prop="dianzuleixing_50">
                  <el-checkbox-group v-model="p50.listDianzuleixing_50" :max="1" @change="changeP50Dianzu()">
                    <el-checkbox label="波纹电阻"/>
                    <el-checkbox label="铝壳电阻"/>
                    <el-checkbox label="波纹电阻箱/柜"/>
                    <el-checkbox label="铝壳电阻箱/柜"/>
                    <el-checkbox label="接地电阻"/>
                    <el-checkbox label="金属管电阻箱柜"/>
                    <el-checkbox label="不锈钢电阻箱/柜"/>
                    <el-checkbox label="负载电阻"/>
                    <el-checkbox label="其他"/>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="箱体材质" prop="xiangti_50">
                  <el-checkbox-group v-model="p50.listXiangti_50" :max="1" @change="changeP50Xiangti()">
                    <el-checkbox label="镀锌板"/>
                    <el-checkbox label="铁板喷塑"/>
                    <el-checkbox label="不锈钢"/>
                    <el-checkbox label="其他"/>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="客户需求" prop="note_50">
                  <el-input type="textarea" v-model="p50.note_50" autosize/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="使用场所" prop="changsuo_50">
                  <el-input type="textarea" v-model="p50.changsuo_50" autosize/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-checkbox style="margin-left: 20px;" v-model="p50.optionPrice" label="报价"/>
                <el-checkbox v-model="p50.optionDemo" label="打样"/>
                <el-checkbox v-model="p50.optionSpecification" label="规格书"/>
                <el-checkbox v-model="p50.optionClient" label="承认书"/>
                <el-checkbox v-model="p50.optionBom" label="物料清单"/>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <!--60-->
        <div v-if="showP60">
          <el-form ref="form"
                   :model="p60"
                   :rules="showP60? ruleValidateP60:ruleValidate0"
                   class="form"
                   style="height: 200px;"
                   label-width="140px" :disabled="disabled">
            <el-row>
              <el-col :span="8">
                <el-form-item label="单相/三相" prop="danxiang_60">
                  <el-input v-model="p60.danxiang_60"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="系统工作电压（U)" prop="dianya_60">
                  <el-input v-model="p60.dianya_60"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="功率（变频器KW）" prop="gonglv_60">
                  <el-input v-model="p60.gonglv_60"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="电感量(mH)" prop="diangan_60">
                  <el-input v-model="p60.diangan_60"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="额定电流（A)" prop="dianliu_60">
                  <el-input v-model="p60.dianliu_60"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="基波频率（Hz）" prop="jiboHz_60">
                  <el-input v-model="p60.jiboHz_60"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="温升（K)" prop="wensheng_60">
                  <el-input v-model="p60.wensheng_60"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="导体材料(铜/铝）" prop="daoti_60">
                  <el-input v-model="p60.daoti_60"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="开关频率（KHz）" prop="kaiguanHz_60">
                  <el-input v-model="p60.kaiguanHz_60"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="绝缘等级（H/F)" prop="jueyuan_60">
                  <el-input v-model="p60.jueyuan_60"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="噪音(dB)" prop="zaoyin_60">
                  <el-input v-model="p60.zaoyin_60"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="冷却方式" prop="lengque_60">
                  <el-input v-model="p60.lengque_60"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="尺寸要求" prop="chicun_60">
                  <el-input v-model="p60.chicun_60"/>
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item label="其它" prop="note_60">
                  <el-input type="textarea" v-model="p60.note_60" autosize/>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div
              style="text-align: center;border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px">
            特殊要求(带*为必须填写项目)
          </div>
          <el-form ref="form"
                   :model="p60"
                   :rules="showP60? ruleValidateP60:ruleValidate0"
                   class="form"
                   label-width="140px" :disabled="disabled">
            <el-row>
              <el-col :span="8">
                <el-form-item label="有无客户文件" prop="filename_60">
                  <el-input v-model="p60.filename_60"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="有无测试要求" prop="test_60">
                  <el-input v-model="p60.test_60"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="有无出口要求" prop="chukou_60">
                  <el-input v-model="p60.chukou_60"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="过载要求（过载时电感跌落要求）" label-width="350px" prop="guozai_60">
                  <el-input v-model="p60.guozai_60"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="接线排表面（如镀锡/镀镍）" label-width="350px" prop="jiexian_60">
                  <el-input v-model="p60.jiexian_60"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="有无客户样品（是完全按照样品设计还是按我司设计）" label-width="350px" prop="demo_60">
                  <el-input v-model="p60.demo_60"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="使用场所（如使用于变频器/风电/电动车/光伏等）" label-width="350px" prop="changsuo_60">
                  <el-input v-model="p60.changsuo_60"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="防护要求(如ROHS/72小时盐雾/UL/三防等）" label-width="350px" prop="fanghu_60">
                  <el-input v-model="p60.fanghu_60"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-checkbox style="margin-left: 20px;" v-model="p60.optionPrice" label="报价"/>
                <el-checkbox v-model="p60.optionDemo" label="打样"/>
                <el-checkbox v-model="p60.optionSpecification" label="规格书"/>
                <el-checkbox v-model="p60.optionClient" label="承认书"/>
                <el-checkbox v-model="p60.optionBom" label="物料清单"/>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <!--70-->
        <div v-if="showP70">
          <el-form ref="form"
                   :model="p70"
                   :rules="showP70? ruleValidateP70:ruleValidate0"
                   class="form"
                   style="height: 200px;"
                   label-width="140px" :disabled="disabled">
            <el-row>
              <el-col :span="8">
                <el-form-item label="单相/三相" prop="danxiang_70">
                  <el-input v-model="p70.danxiang_70"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="系统工作电压（U)" prop="dianya_70">
                  <el-input v-model="p70.dianya_70"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="功率（变频器KW）" prop="gonlv_70">
                  <el-input v-model="p70.gonlv_70"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="电感量(mH)" prop="diangan_70">
                  <el-input v-model="p70.diangan_70"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="额定电流（A)" prop="dianliu_70">
                  <el-input v-model="p70.dianliu_70"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="基波频率（Hz）" prop="jiboHz_70">
                  <el-input v-model="p70.jiboHz_70"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="温升（K)" prop="wensheng_70">
                  <el-input v-model="p70.wensheng_70"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="导体材料(铜/铝）" prop="daoti_70">
                  <el-input v-model="p70.daoti_70"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="开关频率（KHz）" prop="kaiguanHz_70">
                  <el-input v-model="p70.kaiguanHz_70"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="绝缘等级（H/F)" prop="jueyuan_70">
                  <el-input v-model="p70.jueyuan_70"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="噪音(dB)" prop="zaoyin_70">
                  <el-input v-model="p70.zaoyin_70"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="冷却方式" prop="lengque_70">
                  <el-input v-model="p70.lengque_70"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="尺寸要求" prop="chicun_70">
                  <el-input v-model="p70.chicun_70"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="连接方式" prop="lianjie_70">
                  <el-checkbox-group v-model="p70.listLianjie_70" :max="1" @change="changeP70Lianjie()">
                    <el-checkbox label="硬连接"/>
                    <el-checkbox label="软连接"/>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="其它" prop="note_70">
                  <el-input type="textarea" v-model="p70.note_70" autosize/>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div
              style="text-align: center;border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px">
            特殊要求(带*为必须填写项目)
          </div>
          <el-form ref="form"
                   :model="p70"
                   :rules="showP70? ruleValidateP70:ruleValidate0"
                   class="form"
                   label-width="140px" :disabled="disabled">
            <el-row>
              <el-col :span="8">
                <el-form-item label="有无客户文件" prop="filename_70">
                  <el-input v-model="p70.filename_70"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="有无测试要求" prop="test_70">
                  <el-input v-model="p70.test_70"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="有无出口要求" prop="chukou_70">
                  <el-input v-model="p70.chukou_70"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="过载要求（过载时电感跌落要求）" label-width="350px" prop="guozai_70">
                  <el-input v-model="p70.guozai_70"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="接线排表面（如镀锡/镀镍）" label-width="350px" prop="jiexian_70">
                  <el-input v-model="p70.jiexian_70"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="有无客户样品（是完全按照样品设计还是按我司设计）" label-width="350px" prop="demo_70">
                  <el-input v-model="p70.demo_70"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="使用场所（如使用于变频器/风电/电动车/光伏等）" label-width="350px" prop="changsuo_70">
                  <el-input v-model="p70.changsuo_70"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="防护要求(如ROHS/72小时盐雾/UL/三防等）" label-width="350px" prop="fanghu_70">
                  <el-input v-model="p70.fanghu_70"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-checkbox style="margin-left: 20px;" v-model="p70.optionPrice" label="报价"/>
                <el-checkbox v-model="p70.optionDemo" label="打样"/>
                <el-checkbox v-model="p70.optionSpecification" label="规格书"/>
                <el-checkbox v-model="p70.optionClient" label="承认书"/>
                <el-checkbox v-model="p70.optionBom" label="物料清单"/>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-tab-pane>
      <el-tab-pane name="p2" label="附件">
        <el-form
            ref="form"
            :model="productApplicationVO"
            :rules="ruleValidate"
            class="form"
            label-width="80px">
          <el-row>
            <!--        <el-divider/>-->
            <upload-file
                ref="upload" :disabled="disabled"
                :show-file-list="false"
                :auth-index="authIndex"
                style="text-align: right;margin-top: 2px;"
                @upload-success="uploadSuccess"/>
            <el-table :data="productApplicationVO.attachments" height="60vh" border>
              <el-table-column prop="fileName" align="left" label="附件" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{ scope.row.fileName }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="creatorName" align="left" label="创建人" width="120">
                <template slot-scope="scope">
                  <span>{{ scope.row.creatorName }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="createTime" align="left" label="创建时间" width="140">
                <template slot-scope="scope">
                  <span>{{ scope.row.createTime }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="120" class-name="vm-table_operate">
                <template slot-scope="scope">
                  <el-button type="primary" @click="downLoad(scope.row)">下载</el-button>
                  <el-button type="danger" @click="productApplicationVO.attachments.splice(scope.$index, 1)">删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-form>
      </el-tab-pane>
      <el-tab-pane name="p3" label="解决方案"
                   v-if="[20].includes(productApplicationVO.status)&&productApplicationVO.showPrice">
        <el-form
            ref="form"
            :model="productApplicationVO"
            class="form"
            label-width="80px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="项目类型">
                <div style="display: flex">
                  {{ constant.productApplicationType[productApplicationVO.applicationType] }}
                  {{ productApplicationVO.applicationSubType }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="订单类型" prop="orderType">
                {{ constant.productOrderType[productApplicationVO.orderType] }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="订单子类型" prop="orderStandard">
                {{ constant.productOrderStandard[productApplicationVO.orderStandard] }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="productApplicationVO.showPrice">
            <el-col :span="8">
              <el-form-item label="销售价格" prop="salePrice">
                <el-input v-model="productApplicationVO.salePrice" readonly/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="(productApplicationVO.applicationType===10&&productApplicationVO.showCostPrice)
          ||(productApplicationVO.applicationType===20&&productApplicationVO.showPrice)">
            <el-col :span="8">
              <el-form-item label="材料成本" prop="materialCost">
                <el-input v-model="productApplicationVO.materialCost" readonly/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="人工成本" prop="manualCost">
                <el-input v-model="productApplicationVO.manualCost" readonly/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="出厂价" prop="productCost">
                <el-input v-model="productApplicationVO.productCost" readonly/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="物料编号" prop="materialNo">
                <el-input v-model="productApplicationVO.materialNo" readonly/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="订单数量" prop="orderQty">
                <el-input v-model="productApplicationVO.orderQty" readonly/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="规格型号" prop="materialSpecification">
                <el-input v-model="productApplicationVO.materialSpecification" readonly/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="BOM编号" prop="bomNo">
                <el-input v-model="productApplicationVO.bomNo" readonly/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="操作卡编号" prop="esopNo">
                <el-input v-model="productApplicationVO.esopNo" readonly/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="技术方案">
            <el-input v-model="productApplicationVO.solution" type="textarea" readonly/>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
    <customer-select ref="selectCustomerName" @select="selectCustomerName"/>
    <material-type-selector ref="selectMaterialType" @select="selectMaterialType"/>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit(0)">保存</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit(1)">保存并提交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import constants from "../../../util/constants";
import CustomerSelect from "@/views/information/Customer/CustomerSelect";
import UploadFile from "@/components/UploadFile";
import constant from "@/util/constant";
import MaterialTypeSelector from "@/views/information/MaterialTypeName/MaterialTypeSelector";

export default {
  name: "ProductionApplicationEdit",
  components: {
    CustomerSelect,
    UploadFile,
    MaterialTypeSelector,
  },
  data() {
    return {
      authIndex: 624,
      constants,
      constant,
      positionList: [],
      dialogVisible: false,
      submitLoading: false,
      disabled: false,
      defaultTabName: "p1",
      showP10: false,
      showP20: false,
      showP30: false,
      showP40: false,
      showP50: false,
      showP60: false,
      showP70: false,
      customerLevels: constant.toSelect(constant.customerLevel),
      productSpecification: [],
      p10: {
        optionPrice: false,
        optionDemo: false,
        optionSpecification: false,
        optionClient: false,
        optionBom: false,
        dianliu_10: "",
        dianya_10: "",
        danxiang_10: "",
        listDanxiang_10: [],
        chicun_10: "",
        listChicun_10: [],
        note_10: "",
        changsuo_10: "",
      },
      p20: {
        optionPrice: false,
        optionDemo: false,
        optionSpecification: false,
        optionClient: false,
        optionBom: false,
        danxiang_20: "",
        rongliang_20: "",
        chujidianya_20: "",
        cijidianya_20: "",
        chujidianliu_20: "",
        cijidianliu_20: "",
        jiboHz_20: "",
        kaiguanHz_20: "",
        wensheng_20: "",
        xiaolv_20: "",
        daoti_20: "",
        chicun_20: "",
        note_20: "",
        filePath_20: "",
        filename_20: "",
        test_20: "",
        chukou_20: "",
        guozai_20: "",
        jiexianpai_20: "",
        demo_20: "",
        changsuo_20: "",
        fanghu_20: "",
      },
      p30: {
        optionPrice: false,
        optionDemo: false,
        optionSpecification: false,
        optionClient: false,
        optionBom: false,
        danxiang_30: "",
        diangan_30: "",
        dianrongrongliang_30: "",
        dianliu_30: "",
        dianya_30: "",
        wensheng_30: "",
        dianrongdianya_30: "",
        lengque_30: "",
        diankang_30: "",
        zaoyin_30: "",
        daoti_30: "",
        chicun_30: "",
        note_30: "",
        filePath_30: "",
        filename_30: "",
        test_30: "",
        chukou_30: "",
        guozai_30: "",
        jiexian_30: "",
        demo_30: "",
        fanghu_30: "",
      },
      p40: {
        optionPrice: false,
        optionDemo: false,
        optionSpecification: false,
        optionClient: false,
        optionBom: false,
        danxiang_40: "",
        dianya_40: "",
        gonlv_40: "",
        diangan_40: "",
        dianliu_40: "",
        jiboHz_40: "",
        wensheng_40: "",
        daoti_40: "",
        kaiguanHz_40: "",
        jueyuan_40: "",
        zaoyin_40: "",
        lengque_40: "",
        chicun_40: "",
        listLianjie_40: [],
        lianjie_40: "",
        note_40: "",
        filePath_40: "",
        filename_40: "",
        test_40: "",
        chukou_40: "",
        guozai_40: "",
        jiexian_40: "",
        demo_40: "",
        changsuo_40: "",
        fanghu_40: "",
      },
      p50: {
        optionPrice: false,
        optionDemo: false,
        optionSpecification: false,
        optionClient: false,
        optionBom: false,
        gonglv_50: "",
        zuzhi_50: "",
        dianya_50: "",
        naiya_50: "",
        renzheng_50: "",
        listRenzheng_50: [],
        renzhengNote_50: "",
        dianzuleixing_50: "",
        listDianzuleixing_50: [],
        dianzuleixingNote_50: "",
        xiangti_50: "",
        listXiangti_50: [],
        xiangtiNote_50: "",
        note_50: "",
        changsuo_50: "",
      },
      p60: {
        optionPrice: false,
        optionDemo: false,
        optionSpecification: false,
        optionClient: false,
        optionBom: false,
        danxiang_60: "",
        dianya_60: "",
        gonglv_60: "",
        diangan_60: "",
        dianliu_60: "",
        jiboHz_60: "",
        wensheng_60: "",
        daoti_60: "",
        kaiguanHz_60: "",
        jueyuan_60: "",
        zaoyin_60: "",
        lengque_60: "",
        chicun_60: "",
        note_60: "",
        filePath_60: "",
        filename_60: "",
        test_60: "",
        chukou_60: "",
        guozai_60: "",
        jiexian_60: "",
        demo_60: "",
        changsuo_60: "",
        fanghu_60: "",
      },
      p70: {
        optionPrice: false,
        optionDemo: false,
        optionSpecification: false,
        optionClient: false,
        optionBom: false,
        danxiang_70: "",
        dianya_70: "",
        gonlv_70: "",
        diangan_70: "",
        dianliu_70: "",
        jiboHz_70: "",
        wensheng_70: "",
        daoti_70: "",
        kaiguanHz_70: "",
        jueyuan_70: "",
        zaoyin_70: "",
        lengque_70: "",
        chicun_70: "",
        listLianjie_70: [],
        lianjie_70: "",
        note_70: "",
        filePath_70: "",
        filename_70: "",
        test_70: "",
        chukou_70: "",
        guozai_70: "",
        jiexian_70: "",
        demo_70: "",
        changsuo_70: "",
        fanghu_70: "",
      },
      productApplicationVO: {
        pkId: 0,
        no: "",
        status: 0,
        productName: "",
        applicationType: 20,
        applicationSubType: "",
        productCategory: 10,
        specificationType: "",
        customerNo: "",
        customerName: "",
        productCode: "",
        customerLevel: 4,
        materialTypeId: 0,
        materialTypeName: "",
        materialTypeNo: "",
        note: "",
        materialCost: "",
        manualCost: "",
        productCost: "",
        solution: "",
        engeApproveName: "",
        salePrice: 0,
        showPrice: false,
        showCostPrice: false,
        orderType: "",
        orderStandard: "",
        orderQty: "",
        preOrderQty: "",
        materialNo: "",
        materialSpecification: "",
        bomNo: "",
        esopNo: "",
        attachments: [],
        details: [],
      },
      ruleValidate: {
        productName: {required: true, message: "请输入产品名称", trigger: "blur"},
        preOrderQty: {required: true, message: "请输入预计用量", trigger: "blur"},
        customerName: {required: true, message: "请选择客户名称", trigger: "change"},
        productCode: {required: true, message: "请输入产品代码", trigger: "blur"},
        specificationType: {required: true, message: "产品规格不能为空", trigger: "blur"},
        customerNo: {required: true, message: "请输入客户编号", trigger: "blur"},
        materialTypeName: {required: true, message: "请选择交货部门", trigger: "change"},
      },
      ruleValidate0: {},
      ruleValidateP10: {
        dianliu_10: {required: true, message: "请输入", trigger: "blur"},
        dianya_10: {required: true, message: "请输入", trigger: "blur"},
        danxiang_10: {required: true, message: "请选择", trigger: "blur"},
        chicun_10: {required: true, message: "请选择", trigger: "blur"},
        note_10: {required: true, message: "请输入", trigger: "blur"},
        changsuo_10: {required: true, message: "请输入", trigger: "blur"},
      },
      ruleValidateP20: {
        danxiang_20: {required: true, message: "请输入", trigger: "blur"},
        rongliang_20: {required: true, message: "请输入", trigger: "blur"},
        chujidianya_20: {required: true, message: "请选择", trigger: "blur"},
        cijidianya_20: {required: true, message: "请选择", trigger: "blur"},
        jiboHz_20: {required: true, message: "请选择", trigger: "blur"},
        kaiguanHz_20: {required: true, message: "请选择", trigger: "blur"},
        chujidianliu_20: {required: true, message: "请输入", trigger: "blur"},
        cijidianliu_20: {required: true, message: "请输入", trigger: "blur"},
        wensheng_20: {required: true, message: "请输入", trigger: "blur"},
        xiaolv_20: {required: true, message: "请输入", trigger: "blur"},
        daoti_20: {required: true, message: "请输入", trigger: "blur"},
        chicun_20: {required: true, message: "请输入", trigger: "blur"},
        changsuo_20: {required: true, message: "请输入", trigger: "blur"},
        fanghu_20: {required: true, message: "请输入", trigger: "blur"},
        filename_20: {required: true, message: "请输入", trigger: "blur"},
        test_20: {required: true, message: "请输入", trigger: "blur"},
        chukou_20: {required: true, message: "请输入", trigger: "blur"},
        note_20: {required: true, message: "请输入", trigger: "blur"},
        guozai_20: {required: true, message: "请输入", trigger: "blur"},
        demo_20: {required: true, message: "请输入", trigger: "blur"},
        jiexianpai_20: {required: true, message: "请输入", trigger: "blur"},
      },
      ruleValidateP30: {
        danxiang_30: {required: true, message: "请输入", trigger: "blur"},
        diangan_30: {required: true, message: "请输入", trigger: "blur"},
        dianrongrongliang_30: {required: true, message: "请输入", trigger: "blur"},
        dianliu_30: {required: true, message: "请输入", trigger: "blur"},
        dianya_30: {required: true, message: "请输入", trigger: "blur"},
        wensheng_30: {required: true, message: "请输入", trigger: "blur"},
        dianrongdianya_30: {required: true, message: "请输入", trigger: "blur"},
        lengque_30: {required: true, message: "请输入", trigger: "blur"},
        diankang_30: {required: true, message: "请输入", trigger: "blur"},
        zaoyin_30: {required: true, message: "请输入", trigger: "blur"},
        daoti_30: {required: true, message: "请输入", trigger: "blur"},
        chicun_30: {required: true, message: "请输入", trigger: "blur"},
        note_30: {required: true, message: "请输入", trigger: "blur"},
        filename_30: {required: true, message: "请输入", trigger: "blur"},
        test_30: {required: true, message: "请输入", trigger: "blur"},
        chukou_30: {required: true, message: "请输入", trigger: "blur"},
        guozai_30: {required: true, message: "请输入", trigger: "blur"},
        jiexian_30: {required: true, message: "请输入", trigger: "blur"},
        demo_30: {required: true, message: "请输入", trigger: "blur"},
        fanghu_30: {required: true, message: "请输入", trigger: "blur"},
      },
      ruleValidateP40: {
        danxiang_40: {required: true, message: "请输入", trigger: "blur"},
        dianya_40: {required: true, message: "请输入", trigger: "blur"},
        gonlv_40: {required: true, message: "请输入", trigger: "blur"},
        diangan_40: {required: true, message: "请输入", trigger: "blur"},
        dianliu_40: {required: true, message: "请输入", trigger: "blur"},
        jiboHz_40: {required: true, message: "请输入", trigger: "blur"},
        wensheng_40: {required: true, message: "请输入", trigger: "blur"},
        daoti_40: {required: true, message: "请输入", trigger: "blur"},
        kaiguanHz_40: {required: true, message: "请输入", trigger: "blur"},
        jueyuan_40: {required: true, message: "请输入", trigger: "blur"},
        zaoyin_40: {required: true, message: "请输入", trigger: "blur"},
        lengque_40: {required: true, message: "请输入", trigger: "blur"},
        chicun_40: {required: true, message: "请输入", trigger: "blur"},
        note_40: {required: true, message: "请输入", trigger: "blur"},
        filename_40: {required: true, message: "请输入", trigger: "blur"},
        test_40: {required: true, message: "请输入", trigger: "blur"},
        chukou_40: {required: true, message: "请输入", trigger: "blur"},
        guozai_40: {required: true, message: "请输入", trigger: "blur"},
        jiexian_40: {required: true, message: "请输入", trigger: "blur"},
        demo_40: {required: true, message: "请输入", trigger: "blur"},
        changsuo_40: {required: true, message: "请输入", trigger: "blur"},
        fanghu_40: {required: true, message: "请输入", trigger: "blur"},
        lianjie_40: {required: true, message: "请输入", trigger: "blur"},
      },
      ruleValidateP50: {
        gonglv_50: {required: true, message: "请输入", trigger: "blur"},
        zuzhi_50: {required: true, message: "请输入", trigger: "blur"},
        dianya_50: {required: true, message: "请输入", trigger: "blur"},
        naiya_50: {required: true, message: "请输入", trigger: "blur"},
        renzheng_50: {required: true, message: "请输入", trigger: "blur"},
        dianzuleixing_50: {required: true, message: "请输入", trigger: "change"},
        xiangti_50: {required: true, message: "请输入", trigger: "change"},
        note_50: {required: true, message: "请输入", trigger: "change"},
        changsuo_50: {required: true, message: "请输入", trigger: "change"},
      },
      ruleValidateP60: {
        danxiang_60: {required: true, message: "请输入", trigger: "blur"},
        dianya_60: {required: true, message: "请输入", trigger: "blur"},
        gonglv_60: {required: true, message: "请输入", trigger: "blur"},
        diangan_60: {required: true, message: "请输入", trigger: "blur"},
        dianliu_60: {required: true, message: "请输入", trigger: "blur"},
        jiboHz_60: {required: true, message: "请输入", trigger: "blur"},
        wensheng_60: {required: true, message: "请输入", trigger: "blur"},
        daoti_60: {required: true, message: "请输入", trigger: "blur"},
        kaiguanHz_60: {required: true, message: "请输入", trigger: "blur"},
        jueyuan_60: {required: true, message: "请输入", trigger: "blur"},
        zaoyin_60: {required: true, message: "请输入", trigger: "blur"},
        lengque_60: {required: true, message: "请输入", trigger: "blur"},
        chicun_60: {required: true, message: "请输入", trigger: "blur"},
        note_60: {required: true, message: "请输入", trigger: "blur"},
        filename_60: {required: true, message: "请输入", trigger: "blur"},
        test_60: {required: true, message: "请输入", trigger: "blur"},
        chukou_60: {required: true, message: "请输入", trigger: "blur"},
        guozai_60: {required: true, message: "请输入", trigger: "blur"},
        jiexian_60: {required: true, message: "请输入", trigger: "blur"},
        demo_60: {required: true, message: "请输入", trigger: "blur"},
        changsuo_60: {required: true, message: "请输入", trigger: "blur"},
        fanghu_60: {required: true, message: "请输入", trigger: "blur"},
      },
      ruleValidateP70: {
        danxiang_70: {required: true, message: "请输入", trigger: "blur"},
        dianya_70: {required: true, message: "请输入", trigger: "blur"},
        gonlv_70: {required: true, message: "请输入", trigger: "blur"},
        diangan_70: {required: true, message: "请输入", trigger: "blur"},
        dianliu_70: {required: true, message: "请输入", trigger: "blur"},
        jiboHz_70: {required: true, message: "请输入", trigger: "blur"},
        wensheng_70: {required: true, message: "请输入", trigger: "blur"},
        daoti_70: {required: true, message: "请输入", trigger: "blur"},
        kaiguanHz_70: {required: true, message: "请输入", trigger: "blur"},
        jueyuan_70: {required: true, message: "请输入", trigger: "blur"},
        zaoyin_70: {required: true, message: "请输入", trigger: "blur"},
        lengque_70: {required: true, message: "请输入", trigger: "blur"},
        chicun_70: {required: true, message: "请输入", trigger: "blur"},
        note_70: {required: true, message: "请输入", trigger: "blur"},
        filename_70: {required: true, message: "请输入", trigger: "blur"},
        test_70: {required: true, message: "请输入", trigger: "blur"},
        chukou_70: {required: true, message: "请输入", trigger: "blur"},
        guozai_70: {required: true, message: "请输入", trigger: "blur"},
        jiexian_70: {required: true, message: "请输入", trigger: "blur"},
        demo_70: {required: true, message: "请输入", trigger: "blur"},
        changsuo_70: {required: true, message: "请输入", trigger: "blur"},
        fanghu_70: {required: true, message: "请输入", trigger: "blur"},
        lianjie_70: {required: true, message: "请输入", trigger: "blur"},
      },
    };
  },
  methods: {
    open(id, disabled) {
      this.dialogVisible = true;
      this.defaultTabName = "p1";
      this.showP10 = false;
      this.showP20 = false;
      this.showP30 = false;
      this.showP40 = false;
      this.showP50 = false;
      this.showP60 = false;
      this.showP70 = false;
      if (id > 0) {
        this.productApplicationVO.pkId = id;
        this.getData();
      } else {
        this.getNode();
      }
      if (disabled) {
        this.disabled = true;
      }
      this.categoryChange();
    },

    getData() {
      this.$http.get("basic", `productApplications/${this.productApplicationVO.pkId}`).then((resp) => {
        if (resp.success) {
          this.productApplicationVO = resp.data;
          this.productSpecification = [];
          if ([20, 40, 60, 70].includes(this.productApplicationVO.productCategory)) {
            this.productSpecification.push(this.productApplicationVO.specificationType);
          }
          console.log(this.productSpecification);
          this.$nextTick(() => {
            this.showP10 = false;
            this.showP20 = false;
            this.showP30 = false;
            this.showP40 = false;
            this.showP50 = false;
            this.showP60 = false;
            this.showP70 = false;
            if (this.productApplicationVO.productCategory === 10) {
              this.showP10 = true;
            }
            if (this.productApplicationVO.productCategory === 20) {
              this.showP20 = true;
            }
            if (this.productApplicationVO.productCategory === 30) {
              this.showP30 = true;
            }
            if (this.productApplicationVO.productCategory === 40) {
              this.showP40 = true;
            }
            if (this.productApplicationVO.productCategory === 50) {
              this.showP50 = true;
            }
            if (this.productApplicationVO.productCategory === 60) {
              this.showP60 = true;
            }
            if (this.productApplicationVO.productCategory === 70) {
              this.showP70 = true;
            }
          });

          if (this.productApplicationVO.details) {
            this.p10 = Object.assign(this.p10, this.productApplicationVO.details[0]);
            this.p20 = Object.assign(this.p20, this.productApplicationVO.details[0]);
            this.p30 = Object.assign(this.p30, this.productApplicationVO.details[0]);
            this.p40 = Object.assign(this.p40, this.productApplicationVO.details[0]);
            this.p50 = Object.assign(this.p50, this.productApplicationVO.details[0]);
            this.p60 = Object.assign(this.p60, this.productApplicationVO.details[0]);
            this.p70 = Object.assign(this.p70, this.productApplicationVO.details[0]);

            this.p10.listChicun_10 = [];
            this.p10.listDanxiang_10 = [];
            if (this.p10.chicun_10) {
              this.p10.listChicun_10.push(this.p10.chicun_10);
            }
            if (this.p10.danxiang_10) {
              this.p10.listDanxiang_10.push(this.p10.danxiang_10);
            }

            this.p40.listLianjie_40 = [];
            if (this.p40.lianjie_40) {
              this.p40.listLianjie_40.push(this.p40.lianjie_40);
            }

            this.p50.listRenzheng_50 = [];
            this.p50.listDianzuleixing_50 = [];
            this.p50.listXiangti_50 = [];
            if (this.p50.renzheng_50) {
              this.p50.listRenzheng_50.push(this.p50.renzheng_50);
            }
            if (this.p50.xiangti_50) {
              this.p50.listXiangti_50.push(this.p50.xiangti_50);
            }
            if (this.p50.dianzuleixing_50) {
              this.p50.listDianzuleixing_50.push(this.p50.dianzuleixing_50);
            }
            this.p70.listLianjie_70 = [];
            if (this.p70.lianjie_70) {
              this.p70.listLianjie_70.push(this.p70.lianjie_70);
            }


          }
        }
      });
    },
    // 下载
    downLoad(row) {
      this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(row.filePath)}`).then((res) => {
        if (res.success) {
          window.open(res.data);
        }
      });
    },
    // 获取编号
    getNode() {
      this.$http.get("basic", "productApplications/genNO").then((resp) => {
        if (resp.success) {
          this.productApplicationVO.no = resp.data;
        }
      });
    },
    categoryChange() {
      this.productSpecification = [];
      this.productApplicationVO.specificationType = "";
      this.showP10 = false;
      this.showP20 = false;
      this.showP30 = false;
      this.showP40 = false;
      this.showP50 = false;
      this.showP60 = false;
      this.showP70 = false;
      if (this.productApplicationVO.productCategory === 10) {
        this.showP10 = true;
      }
      if (this.productApplicationVO.productCategory === 20) {
        this.showP20 = true;
      }
      if (this.productApplicationVO.productCategory === 30) {
        this.showP30 = true;
      }
      if (this.productApplicationVO.productCategory === 40) {
        this.showP40 = true;
      }
      if (this.productApplicationVO.productCategory === 50) {
        this.showP50 = true;
      }
      if (this.productApplicationVO.productCategory === 60) {
        this.showP60 = true;
      }
      if (this.productApplicationVO.productCategory === 70) {
        this.showP70 = true;
      }
    },
    // 选择客户
    selectCustomerName(row) {
      this.productApplicationVO.customerId = row.customerID;
      this.productApplicationVO.customerName = row.customerName;
      this.productApplicationVO.customerNo = row.outerNo;
      this.productApplicationVO.customerLevel = row.customerLevel;
    },
    uploadSuccess(fileList) {
      if (fileList.length) {
        const params = {
          fileName: fileList[0].name,
          filePath: fileList[0].key,
        };
        this.productApplicationVO.attachments.push(params);
      }
    },

    // 编辑、新建
    handleSubmit(isSave) {
      //验证header
      if (!(this.productApplicationVO.productName && this.productApplicationVO.customerName
          && this.productApplicationVO.specificationType && this.productApplicationVO.productCode
          && this.productApplicationVO.customerNo && this.productApplicationVO.materialTypeName
          && this.productApplicationVO.preOrderQty)) {
        this.$message.error("请确认必填项是否有值.");
        return;
      }
      if (this.productApplicationVO.productCategory === 10) {
        if (!(this.p10.optionPrice || this.p10.optionClient || this.p10.optionDemo || this.p10.optionBom || this.p10.optionSpecification)) {
          this.$message.error("请勾选报价、打样、规格等信息.");
          return;
        }
        if (!(this.p10.dianliu_10 && this.p10.dianya_10 && this.p10.danxiang_10 && this.p10.chicun_10 && this.p10.note_10 && this.p10.changsuo_10)) {
          this.$message.error("请确认必填项是否有值.");
          return;
        }
      }

      if (this.productApplicationVO.productCategory === 20) {
        if (!(this.p20.optionPrice || this.p20.optionClient || this.p20.optionDemo || this.p20.optionBom || this.p20.optionSpecification)) {
          this.$message.error("请勾选报价、打样、规格等信息.");
          return;
        }
        if (!(this.p20.danxiang_20 && this.p20.rongliang_20 && this.p20.chujidianya_20 && this.p20.cijidianya_20 && this.p20.jiboHz_20 && this.p20.kaiguanHz_20
            && this.p20.chujidianliu_20 && this.p20.cijidianliu_20 && this.p20.wensheng_20 && this.p20.xiaolv_20 && this.p20.daoti_20 && this.p20.chicun_20
            && this.p20.changsuo_20 && this.p20.fanghu_20 && this.p20.filename_20 && this.p20.test_20 && this.p20.chukou_20 && this.p20.note_20
            && this.p20.guozai_20 && this.p20.demo_20 && this.p20.jiexianpai_20)) {
          this.$message.error("请确认必填项是否有值.");
          return;
        }
      }
      if (this.productApplicationVO.productCategory === 30) {
        if (!(this.p30.optionPrice || this.p30.optionClient || this.p30.optionDemo || this.p30.optionBom || this.p30.optionSpecification)) {
          this.$message.error("请勾选报价、打样、规格等信息.");
          return;
        }
        if (!(this.p30.danxiang_30 && this.p30.diangan_30 && this.p30.dianrongrongliang_30 && this.p30.dianya_30 && this.p30.wensheng_30 && this.p30.dianliu_30
            && this.p30.dianrongdianya_30 && this.p30.lengque_30 && this.p30.diankang_30 && this.p30.zaoyin_30 && this.p30.daoti_30
            && this.p30.chicun_30 && this.p30.note_30 && this.p30.filename_30 && this.p30.test_30 && this.p30.chukou_30
            && this.p30.guozai_30 && this.p30.jiexian_30 && this.p30.demo_30 && this.p30.fanghu_30)) {
          this.$message.error("请确认必填项是否有值.");
          return;
        }

      }
      if (this.productApplicationVO.productCategory === 40) {
        if (!(this.p40.optionPrice || this.p40.optionClient || this.p40.optionDemo || this.p40.optionBom || this.p40.optionSpecification)) {
          this.$message.error("请勾选报价、打样、规格等信息.");
          return;
        }
        if (!(this.p40.danxiang_40 && this.p40.dianya_40 && this.p40.gonlv_40 && this.p40.diangan_40 && this.p40.dianliu_40 && this.p40.jiboHz_40 && this.p40.wensheng_40
            && this.p40.daoti_40 && this.p40.kaiguanHz_40 && this.p40.jueyuan_40 && this.p40.zaoyin_40 && this.p40.lengque_40 && this.p40.chicun_40 && this.p40.note_40
            && this.p40.filename_40 && this.p40.test_40 && this.p40.chukou_40 && this.p40.guozai_40 && this.p40.jiexian_40 && this.p40.demo_40 && this.p40.changsuo_40
            && this.p40.fanghu_40 && this.p40.lianjie_40)) {
          this.$message.error("请确认必填项是否有值.");
          return;
        }
      }
      if (this.productApplicationVO.productCategory === 50) {
        if (!(this.p50.optionPrice || this.p50.optionClient || this.p50.optionDemo || this.p50.optionBom || this.p50.optionSpecification)) {
          this.$message.error("请勾选报价、打样、规格等信息.");
          return;
        }
        if (!(this.p50.gonglv_50 && this.p50.zuzhi_50 && this.p50.dianya_50 && this.p50.naiya_50 && this.p50.renzheng_50
            && this.p50.dianzuleixing_50 && this.p50.xiangti_50 && this.p50.note_50 && this.p50.changsuo_50)) {
          this.$message.error("请确认必填项是否有值.");
          return;
        }
      }
      if (this.productApplicationVO.productCategory === 60) {
        if (!(this.p60.optionPrice || this.p60.optionClient || this.p60.optionDemo || this.p60.optionBom || this.p60.optionSpecification)) {
          this.$message.error("请勾选报价、打样、规格等信息.");
          return;
        }
        if (!(this.p60.danxiang_60 && this.p60.dianya_60 && this.p60.gonglv_60 && this.p60.diangan_60 && this.p60.dianliu_60 && this.p60.jiboHz_60
            && this.p60.wensheng_60 && this.p60.daoti_60 && this.p60.kaiguanHz_60 && this.p60.jueyuan_60 && this.p60.zaoyin_60 && this.p60.lengque_60
            && this.p60.chicun_60 && this.p60.note_60 && this.p60.filename_60 && this.p60.test_60 && this.p60.chukou_60 && this.p60.guozai_60
            && this.p60.jiexian_60 && this.p60.demo_60 && this.p60.changsuo_60 && this.p60.fanghu_60)) {
          this.$message.error("请确认必填项是否有值.");
          return;
        }
      }

      if (this.productApplicationVO.productCategory === 70) {
        if (!(this.p70.optionPrice ||
              this.p70.optionClient ||
              this.p70.optionDemo ||
              this.p70.optionBom ||
              this.p70.optionSpecification)) {
          this.$message.error("请勾选报价、打样、规格等信息.");
          return;
        }
        if (!( this.p70.danxiang_70 && this.p70.dianya_70 && this.p70.gonlv_70 && this.p70.diangan_70 && this.p70.dianliu_70 && this.p70.jiboHz_70 && this.p70.wensheng_70
            && this.p70.daoti_70 && this.p70.kaiguanHz_70 && this.p70.jueyuan_70 && this.p70.zaoyin_70 && this.p70.lengque_70 && this.p70.chicun_70 && this.p70.note_70
            && this.p70.filename_70 && this.p70.test_70 && this.p70.chukou_70 && this.p70.guozai_70 && this.p70.jiexian_70 && this.p70.demo_70 && this.p70.changsuo_70
            && this.p70.fanghu_70 && this.p70.lianjie_70)) {
          this.$message.error("请确认必填项是否有值.");
          return;
        }
      }


      // this.validValue();
      this.convertValue();
      console.log(this.productApplicationVO);
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          this.$http
              .post("basic", `productApplications/save/${isSave}`, this.productApplicationVO)
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  if (this.productApplicationVO.pkid > 0) {
                    this.$emit("save-success");
                    this.$message.success("编辑成功");
                  } else {
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                  }
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
        }
      });
    },

    dialogClose() {
      this.dialogVisible = false;
      this.disabled = false;
      this.productApplicationVO = {};
      try {
        this.$reset("form");
        // eslint-disable-next-line no-empty
      } catch (e) {
      }
    },

    // 物料类型选择
    selectMaterialType(row) {
      this.productApplicationVO.materialTypeName = row.name;
      this.productApplicationVO.materialTypeId = row.id;
    },
    changeSpecification() {
      this.productApplicationVO.specificationType = "";
      if (this.productSpecification) {
        this.productApplicationVO.specificationType = this.productSpecification.join(",");
      }
    },

    validValue() {

    },
    convertValue() {
      if (this.productApplicationVO.productCategory === 10) {
        this.productApplicationVO.details = [];
        this.productApplicationVO.details.push(this.p10);
      }
      if (this.productApplicationVO.productCategory === 20) {
        this.productApplicationVO.details = [];
        this.productApplicationVO.details.push(this.p20);
      }
      if (this.productApplicationVO.productCategory === 30) {
        this.productApplicationVO.details = [];
        this.productApplicationVO.details.push(this.p30);
      }
      if (this.productApplicationVO.productCategory === 40) {
        this.productApplicationVO.details = [];
        this.productApplicationVO.details.push(this.p40);
      }
      if (this.productApplicationVO.productCategory === 50) {
        this.productApplicationVO.details = [];
        this.productApplicationVO.details.push(this.p50);
      }
      if (this.productApplicationVO.productCategory === 60) {
        this.productApplicationVO.details = [];
        this.productApplicationVO.details.push(this.p60);
      }
      if (this.productApplicationVO.productCategory === 70) {
        this.productApplicationVO.details = [];
        this.productApplicationVO.details.push(this.p70);
      }
    },

    //p10
    changeP10Danxiang() {
      this.p10.danxiang_10 = "";
      if (this.p10.listDanxiang_10) {
        this.p10.danxiang_10 = this.p10.listDanxiang_10.join(",");
      }
    },
    changeP10Chicun() {
      this.p10.chicun_10 = "";
      if (this.p10.listChicun_10) {
        this.p10.chicun_10 = this.p10.listChicun_10.join(",");
      }
    },

    //p40
    changeP40Lianjie() {
      this.p40.lianjie_40 = "";
      if (this.p40.listLianjie_40) {
        this.p40.lianjie_40 = this.p40.listLianjie_40.join(",");
      }
    },

    //p50
    changeP50Renzheng() {
      this.p50.renzheng_50 = "";
      if (this.p50.listRenzheng_50) {
        this.p50.renzheng_50 = this.p50.listRenzheng_50.join(",");
      }
    },
    changeP50Dianzu() {
      this.p50.dianzuleixing_50 = "";
      if (this.p50.listDianzuleixing_50) {
        this.p50.dianzuleixing_50 = this.p50.listDianzuleixing_50.join(",");
      }
    },
    changeP50Xiangti() {
      this.p50.xiangti_50 = "";
      if (this.p50.listXiangti_50) {
        this.p50.xiangti_50 = this.p50.listXiangti_50.join(",");
      }
    },
    //p70
    changeP70Lianjie() {
      this.p70.lianjie_70 = "";
      if (this.p70.listLianjie_70) {
        this.p70.lianjie_70 = this.p70.listLianjie_70.join(",");
      }
    },
  },
};
</script>

<style>
.error-label .el-form-item__label {
  color: #f56c6c;
  transition: color 0.3s;
}

.myLabelStyle {
  color: #f56c6c;
}
</style>
